/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormualrioTipoSociedadCV from './controladorVista/formularioTipoSociedadCV';
import TablaTipoSociedadCV from './controladorVista/tablaTipoSociedadCV';
import { estadoIncial, reductor } from './reductorTipoSociedad';

const TipoSociedad: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaTipoSociedadCV />
        <FormualrioTipoSociedadCV />
    </ProveedorEstado>
);

export default TipoSociedad;
